import { createSlice } from '@reduxjs/toolkit'

// export interface dossiers extends Array<dossier>{}


const richiesteSlice = createSlice({
  name: 'richieste',
  initialState: {
    loaded: false,
    data: [],
  },
  reducers: {
    load: (state, action) => {
        state.loaded = true
        state.data = action.payload
    }
  }
})

export const actions = richiesteSlice.actions;
export default richiesteSlice.reducer;